import { useState } from "react"
import { FaCloudUploadAlt } from "react-icons/fa";
import styled from 'styled-components';
import { Button, LoadingIcon, Modal } from '@prosolve/common-components-ui'
import useIsMobileView from "../../../hooks/useIsMobileView";
import { downloadUrls } from '../../../utils';
import Table from "../../sharedComponents/Table";

const LoadingIconOverride = styled.div`
  margin-right: 7px;
  position: relative;
  top: 1px;
  svg {
    font-size: 18px!important;
  }
`;

const CONSULT_NOTES_SEPARATOR = '<|v|>'

export default ({
  events
}) => {
  const [isModalOpen, setIsModalOpen] = useState()
  const [consultNotesDownloading, setConsultNotesDownloading] = useState(false)

  const isMobileView = useIsMobileView();

  const filteredEvents = events.filter(e => e.consultNotesUrl)

  const columns = [
    {
      field: 'name',
      title: 'Event',
    },
    {
      field: 'consultNotesUrl',
      title: 'Consult Notes',
      renderer: (data = {}) => {
        const { consultNotesUrl } = data

        return (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            fontFamily: '"ProximaSoft-Regular", "Open Sans", sans-serif',
            fontSize: '14px',
            fontStyle: 'italic',
            gap: '10px'
          }}>
            {consultNotesUrl.split(CONSULT_NOTES_SEPARATOR).map(url => {
              return (
                <div>
                  <a href={url} target='_blank' rel='noreferrer' style={{ color: 'rgb(2, 128, 198)' }}>
                    {extractConsultNotesName(url)}
                  </a>
                </div>
              )
            })}
          </div>
        )
      }
    },
  ]

  const extractConsultNotesName = (url) => {
    const fileName = url.substr((url.lastIndexOf('/') || -1) + 1)
    const uploadedName = fileName.substr((fileName.indexOf('_') || -1) + 1)
    return uploadedName
  }

  const downloadAllConsultNotes = async () => {
    const consultNotes = []
    events.forEach(({ consultNotesUrl }) => {
      if (consultNotesUrl) {
        consultNotes.push(consultNotesUrl)
      }
    });

    const allConsultNotes = []
    consultNotes.forEach(consultNote => {
        const splitConsultNote = consultNote.split(CONSULT_NOTES_SEPARATOR)
        allConsultNotes.push(...splitConsultNote)
    });

    if (allConsultNotes.length > 0) {
      setConsultNotesDownloading(true)
      try {
        await downloadUrls(allConsultNotes, 'consult-notes.zip')
      } catch(e) {
        console.log(e)
      }
      setConsultNotesDownloading(false)
    }
  }
  
  return (
    <>
      <Button
        style={{
          display: 'flex',
          padding: '2px 5px',
          border: 'none',
        }}
        onClick={() => setIsModalOpen(true)}
      >
        <FaCloudUploadAlt style={{ color: '#0280c6', fontSize: '18px', marginRight: '5px' }} />
        <span style={{ color: '#565656', fontSize: '14px' }}>Download All Consult Notes</span>
      </Button>
      
      {isModalOpen &&
        <Modal title={'Download Consult Notes'} isAutoHeight={true} onClose={() => setIsModalOpen()} isMobileView={isMobileView} footer={(
          <div style={{ 
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            columnGap: '10px',
            padding: '10px'
          }}>
            <Button
              onClick={() => {
                if (!consultNotesDownloading) {
                  downloadAllConsultNotes()
                }
              }}
            >
              {
                consultNotesDownloading ?
                <LoadingIconOverride>
                  <LoadingIcon />
                </LoadingIconOverride>
                :
                <FaCloudUploadAlt style={{ color: '#0280c6', fontSize: '18px', marginRight: '5px' }} />
              }
              <span style={{ color: '#565656', fontSize: '14px' }}>{consultNotesDownloading ? 'Downloading...' : 'Download All'}</span>
            </Button>
            <Button onClick={() => setIsModalOpen()}>
              {'Close'}
            </Button>
          </div>
        )}>
          <div style={{
            display: 'flex',
            flexDirection: 'column'
          }}>
            <div style={{
              paddingBottom: '15px'
            }}>
              <strong>Note:</strong> Filters on the main event list also apply here.
            </div>
            <Table
              columns={columns}
              data={filteredEvents}
              mobileMode={isMobileView}
            />
          </div>
        </Modal>
      }
    </>
  )
}